import ArrowRightOutlineIcon from '@kcd/design-system/dist/icons/ic__system__arrow_right__outline.svg';
import CloseIcon from '@kcd/design-system/dist/icons/ic__system__dismiss.svg';
import MapIcon from '@kcd/design-system/dist/icons/ic__system__map__filled.svg';
import MoreOutlineIcon from '@kcd/design-system/dist/icons/ic__system__more__outline.svg';
import DismissFilledIcon from '@kcd/design-system/dist/icons/ic_dismiss_circle.svg';

import BrandDefault24x24Icon from './brand_default_icon_24x24.svg';
import BrandDefault48x48Icon from './brand_default_icon_48x48.svg';
import CashnoteIcon from './cashnote.svg';
import CouponCardIcon from './coupon_card.svg';
import CameraIcon from './ic__camera.svg';
import ChevronRightIcon from './ic_chevron_right.svg';
import CheveronRightIcon24x24 from './ic_chevron_right24x24.svg';
import ChevronDownOutlineIcon24x24 from './ic_outline_chevron_down_24x24.svg';
import ThreadIcon16x16 from './ic_thread.svg';
import MoreIcon from './icon_more.svg';
import Home20x20Icon from './img_house20x20.svg';
import MobileVoucher20x20Icon from './img_mobile_voucher20x20.svg';

export {
  ArrowRightOutlineIcon,
  BrandDefault24x24Icon,
  BrandDefault48x48Icon,
  CameraIcon,
  CashnoteIcon,
  CheveronRightIcon24x24,
  ChevronDownOutlineIcon24x24,
  ChevronRightIcon,
  CloseIcon,
  CouponCardIcon,
  DismissFilledIcon,
  Home20x20Icon,
  MapIcon,
  MobileVoucher20x20Icon,
  MoreIcon,
  MoreOutlineIcon,
  ThreadIcon16x16,
};
